module.exports = __webpack_public_path__ + "img/seastop-sump.c71ec078.png";